import { RecordUtils } from "@rsm-hcd/javascript-core";
import { t } from "i18next";
import { Record } from "immutable";
import { PageAccessRecipient } from "models/interfaces/page-access-recipient";
import moment from "moment";

const defaultValues =
    RecordUtils.auditableDefaultValuesFactory<PageAccessRecipient>({
        email: "",
        expiresOn: undefined,
        guid: "",
        pageId: 0,
        userId: undefined,
        page: undefined,
        user: undefined,
    });

export class PageAccessRecipientRecord
    extends Record(defaultValues)
    implements PageAccessRecipient
{
    constructor(params?: PageAccessRecipient) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    public daysUntilAccessExpires(): number | undefined {
        if (!this.expiresOn) {
            return undefined;
        }

        const subscriptionExpirationDate = moment(this.expiresOn);
        const daysUntilSubscriptionExpiration = subscriptionExpirationDate.diff(
            moment(),
            "days"
        );
        if (daysUntilSubscriptionExpiration < 0) {
            return 0;
        }
        return daysUntilSubscriptionExpiration;
    }

    public getExpirationDay(): string | undefined {
        if (!this.expiresOn) {
            return undefined;
        }
        const expirationInDays = this.daysUntilAccessExpires();
        if (expirationInDays === 1) {
            return t("managePageAccess-dayUntilAccessExpires");
        }
        if (expirationInDays === 0) {
            return t("managePageAccess-todayAccessExpires");
        }
        return t("managePageAccess-daysUntilAccessExpires", {
            count: expirationInDays,
        });
    }

    public accessExpired(): boolean {
        return moment(this.expiresOn).isBefore(moment());
    }
}
